import React, { Component } from 'react';
import auth from './auth0';

export default class LoginComponent extends Component {
    constructor(props) {
        super(props);
        
        auth.login();
    }

    render() {
        return (
            <div />
        )
    }
};
